import axiosInstance from "./axiosInstance";

export const getAllPricing = async () => {
  try {
    const response = await axiosInstance.get("/public/pricing", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch pricing data");
  }
};

export const getPricingById = async (id) => {
  try {
    const response = await axiosInstance.get(`/pricingfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch pricing detail");
  }
};

export const createPricing = async (pricingData) => {
  try {

    const response = await axiosInstance.post("/public/pricing", pricingData, {

      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create pricing");
  }
};

export const updatePricing = async (id, pricingData) => {
  try {
    const response = await axiosInstance.put(`/pricing/${id}`, pricingData, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update pricing");
  }
};

export const deletePricing = async (id) => {
  try {
    const response = await axiosInstance.delete(`/pricingdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete pricing");
  }
};

export const getPlanTypes = async () => {
  try {
    const response = await axiosInstance.get("/plan", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan types");
  }
};